import { z } from 'zod'
import type { SensorPacket } from '../types'

const Vector3Schema = z.object({
  x: z.number().finite(),
  y: z.number().finite(),
  z: z.number().finite(),
})

const QuaternionSchema = z.object({
  w: z.number().finite(),
  x: z.number().finite(),
  y: z.number().finite(),
  z: z.number().finite(),
})

const SensorPacketSchema = z.object({
  timestamp: z.number().finite().nonnegative(),
  orientation: QuaternionSchema,
  acceleration: Vector3Schema,
  gyroscope: Vector3Schema,
  extra: z.number().finite(),
})

/**
 * Validates a decoded packet. Returns the packet if valid, null if not.
 * Logs a warning on failure so bad packets are visible during development.
 */
export function validateSensorPacket(packet: unknown): SensorPacket | null {
  const result = SensorPacketSchema.safeParse(packet)
  if (!result.success) {
    console.warn('[Validator] Invalid packet:', result.error.flatten().fieldErrors)
    return null
  }
  return result.data
}
